var svSE = {
  locale: 'sv_SE',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'YYYY-WW',
      date: 'YYYY-MM-DD',
      month: 'YYYY-MM',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'YYYY-MM-DD HH:mm:ss'
    },
    startDay: 0,
    monthList: ['Januari', 'Februari', 'Mars', 'April', 'får', 'Juni', 'Juli', 'Augusti', 'september', 'Oktober', 'November', 'december'],
    shortMonthList: ['Januari', 'Februari', 'Mars', 'April', 'får', 'Juni', 'Juli', 'Augusti', 'september', 'Oktober', 'November', 'december'],
    dayList: ['söndag', 'måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
    shortDayList: ['söndag', 'måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
    shortestDayList: ['dag', 'ett', 'två', 'tre', 'fyra', 'fem', 'sex']
  },
  'dynamic-date': {
    day: 'dag',
    week: 'vecka',
    month: 'månad',
    quarter: 'kvartal',
    year: 'år',
    before: 'Före ${value}${unit}'
  },
  'auto-complete.placeholder': 'Välj',
  'auto-complete.empty': 'Inga data',
  'cascader.titles': ['nivå 1', 'nivå 2', 'Nivå 3', 'nivå 4', 'fem nivåer', 'sex nivåer', 'Sju nivåer', 'Nivå 8'],
  'cascader.empty': 'Inga data',
  'cascader.search': 'Ange sökord',
  'color.custom': 'Anpassad färg',
  'date.year': '${year}år',
  'date.month': 'månad',
  'date.week': 'vecka',
  'date.month-first': false,
  'date-picker.start': 'starttid',
  'date-picker.end': 'Sluttid',
  'date-picker.placeholder': 'Välj datum',
  'date-picker.cancel': 'avbryt',
  'date-picker.apply': 'ansökan',
  'date-picker.invalid-range': 'Tidsintervallet du valt har överskridit det valfria intervallet, vänligen justera',
  'date-comparison.mom': 'Jämfört med föregående period',
  'date-comparison.yoy': 'Denna period förra året',
  'date-comparison.placeholder': 'starttid ~ Sluttid',
  'date-comparison.error-source': 'Välj starttid för jämförelsen',
  'date-comparison.error-target': 'Välj sluttid för jämförelsen',
  'date-comparison.compare': 'kontrast',
  'date-comparison.compare-text': 'kontrast',
  'dynamic-date.customize': 'anpassad',
  'dynamic-date.date-preview': 'Förhandsgranskning av tid',
  'dynamic-date.dynamic-date': 'Dynamisk tid',
  'dynamic-date.interval': 'Tidsenhet',
  'dynamic-date.fixed-date': 'Fast tid',
  'empty.text': 'Inga data',
  'input.placeholder': 'Skriv in',
  'textarea.placeholder': 'Skriv in',
  'list-viewer.empty': 'Inga data',
  'modal.cancel': 'avbryt',
  'modal.ok': 'bestämma',
  'pager.jump': 'Hoppa',
  'pager.total': '${total} poster totalt',
  'pager.size': '${count} items / page',
  'pager.page.placeholder': 'Skriv in',
  'popover.cancel': 'avbryt',
  'popover.ok': 'bestämma',
  'schedule.selected': 'Tid markerad',
  'schedule.clear': 'tom',
  'schedule.separator': '、',
  'schedule.title': 'Datum / tid',
  'select.search.placeholder': 'Skriv in',
  'select.empty': 'Inga data',
  'select.selected': 'Markerad',
  'select.selected-count': '${count} objekt markerat',
  'select.select-all': 'Välj alla',
  'select.placeholder': 'Välj',
  'select.clear': 'tom',
  'tabs.more': 'mer',
  'table.emptyText': 'Innehållet är tomt',
  'table.filter.reset': 'Återställ',
  'table.filter.confirm': 'bestämma',
  'transfer.empty': 'Inga relevanta uppgifter',
  'transfer.placeholder': 'Skriv in',
  'transfer.source': 'Källlista',
  'transfer.target': 'Mållista',
  'tree.empty': 'Inga resultat hittades',
  'tree-select.placeholder': 'Skriv in',
  'tree-select.empty': 'Inga data',
  'time-picker.placeholder': 'Välj en tid',
  'time-range-picker.placeholder': 'Starttid ~ sluttid',
  'upload.error.overflow-count': 'Maximalt antal filer som överskridits',
  'upload.click': 'Klicka på uppladdning',
  'upload.drop': 'Dra filen här, eller',
  'date-time-picker.now': 'detta ögonblick',
  'date-time-picker.ok': 'bestämma',
  'date-time-picker.date': 'Välj datum',
  'date-time-picker.time': 'Välj tid',
  'date-time-picker.placeholder': 'Skriv in',
  'date-time-picker.start': 'Välj startdatumtid',
  'date-time-picker.end': 'Välj slutdatumtid',
  'date-time-picker-panel.start': 'Startdatum',
  'date-time-picker-panel.end': 'Slutdatum',
  'image-view.next': 'Nästa',
  'image-view.prev': 'Föregående',
  'image-view.zoom-in': 'förstora',
  'image-view.zoom-out': 'smal',
  'image-view.zoom-to-origin': 'Ursprunglig storlek',
  'image-view.zoom-to-fit': 'Anpassning',
  'image-view.rotate': 'rotera',
  table: {
    selectionMenu: {
      selectCurrent: 'Select Current',
      selectAll: 'Select All',
      unselectCurrent: 'Unselect Current',
      unselectAll: 'Unselect All'
    }
  }
};
export default svSE;